<template lang="pug">
  #home
    Header
    v-container(fluid)
      v-layout(row wrap)
        v-flex.list.px-2(xs12 sm6)
          List
        v-flex.home-border.pa-3(xs12 sm6)
          v-layout(row wrap d-flex text-xs-center)
            a(@click="downloadImage").link Descargar como imagen

            .link(v-if="user.permission.updateReports")
              a(@click="setEditForm") Editar información
          Postal
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import List from "@/components/List/List.vue";
import Postal from "@/components/Postal/Postal.vue";
import * as d3 from "d3";
import * as html2canvas from "html2canvas";

export default {
  name: "home",
  components: {
    Header,
    List,
    Postal
  },
  data() {
    return {
      user: this.$store.state.user
    };
  },
  computed: {
    record() {
      return this.$store.state.record;
    }
  },
  methods: {
    downloadImage() {
      if (
        this.record["_id"] === "" ||
        typeof this.record["_id"] === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No has seleccionado un folio"
        });
      } else {
        html2canvas(d3.select("#postal").node()).then(canvas => {
          let link = document.createElement("a");
          link.download = 'letraese-folio' + this.record.folio + ".jpeg";
          link.href = canvas.toDataURL("image/jpeg");
          link.click();
        });
      }
    },
    setEditForm() {
      if (
        this.record["_id"] === "" ||
        typeof this.record["_id"] === "undefined"
      ) {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "No has seleccionado un folio"
        });
      } else {
        this.$store.commit("setEditionState", true);
        this.$router.replace("/form");
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.home-border {
  min-width: 600px;
}
</style>
